import { Box, Typography } from '@mui/material';

interface PopoverTitleProps {
  label: string;
  showBorder?: boolean;
}

/**
 * Title component for sidenav popovers with consistent styling.
 */
export function PopoverTitle({ label, showBorder = false }: PopoverTitleProps) {
  return (
    <Box
      sx={{
        px: 2.5,
        py: 1.5,
        ...(showBorder && {
          borderBottom: '1px solid rgba(233, 236, 239, 0.1)',
        }),
      }}
    >
      <Typography
        component="div"
        sx={{
          fontSize: '0.8rem',
          color: '#e9ecef',
          textTransform: 'uppercase',
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}
